import { render, staticRenderFns } from "./nuevaNoticia.vue?vue&type=template&id=32053db8&scoped=true"
import script from "./nuevaNoticia.vue?vue&type=script&lang=js"
export * from "./nuevaNoticia.vue?vue&type=script&lang=js"
import style0 from "./nuevaNoticia.vue?vue&type=style&index=0&id=32053db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32053db8",
  null
  
)

export default component.exports